import React from 'react';
import '../../css/home/CTA.css';
import { Link } from 'react-router-dom';

const CTA = () => {
  return (
    <section className="cta-section">
      <div className="cta-content">
        <h1 className="cta-heading">Your Next Generation of Customers Is Here</h1>
        <p className="cta-subtitle">We'll help you reach them first — start with us today.</p>
        <div className="cta-button-container">
          <Link to="/brands">
            <button className="cta-button">Launch Your Program</button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTA;